import React from 'react';
import { ReadOnlyEditor } from './Editor/Editor';
import { ReadOnlyLetterTitle } from './Editor/LetterTitle';
import { LetterGutter, SimpleLetterGutter } from './LetterGutter';

type LetterViewProps = { letter: { title: string; body: string } };

export const SideCarLetterView = ({ letter }: LetterViewProps) => (
  <LetterGutter>
    <ReadOnlyLetterTitle title={letter.title} />
    <ReadOnlyEditor content={letter.body} />
  </LetterGutter>
);

const LetterView = ({ letter }: LetterViewProps) => (
  <SimpleLetterGutter>
    <ReadOnlyLetterTitle title={letter.title} />
    <ReadOnlyEditor content={letter.body} />
  </SimpleLetterGutter>
);

export default LetterView;
